import {
	EditIntegrationParams,
	VAPARLoginParams,
} from './../../types/integration.types';
import serviceIntegration from '@Apis/serviceIntegration.api';
import {
	CreateIntegrationParams,
	ListIntegrationsParams,
} from '../../types/integration.types';

export const getIntegrationsService = (params?: ListIntegrationsParams) => {
	return serviceIntegration.get('/integrations', { params });
};
export const getIntegrationService = (id: string) => {
	return serviceIntegration.get(`/integration/esri/${id}`);
};
export const validateIntegrationService = (
	portalUrl: string,
	apiKey: string,
) => {
	return serviceIntegration.post('/itpipes/validate', { portalUrl, apiKey });
};
export const updateEsriIntegrationService = (
	params?: EditIntegrationParams,
) => {
	return serviceIntegration.put(`/integration/esri/${params?._id}`, params);
};

export const createIntegrationService = (params: CreateIntegrationParams) => {
	return serviceIntegration.post('/integrations', params);
};

export const deleteEsriIntegrationService = (id: string) => {
	return serviceIntegration.delete(`/integration/esri/${id}`);
};

export const VAPARLoginService = (userData: VAPARLoginParams) => {
	return serviceIntegration.post('/vaparIntegrations/login', userData);
};
